import { Brick, registerBrick } from 'olympe';
import BCP from './DM_BCP.js';

export default class GetFormatOfToBeDeletedBCPs extends Brick {

    addDashWithString(s) {
        if (s) {
            return `- ${s}`;
        } else {
            return '';
        }
    }
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} inputBCPs
     * @param {function(string)} setOutputTextFormat
     */
    update($, [inputBCPs], [setOutputTextFormat]) {
        // Write your code here.
        let finalString = ""
        let index = -1;
        for (let [key, bcpRequest] of Object.entries(inputBCPs)) {
            // let index = key+1;
            const materialID = bcpRequest.get(BCP.materialIdProp);
            const materialDesc = bcpRequest.get(BCP.materialDescriptionProp);
            const plantID = bcpRequest.get(BCP.plantIdProp);
            const plantDesc = bcpRequest.get(BCP.plantDescriptionProp);
            const requestor = bcpRequest.get(BCP.requestorProp).split(';')[0];
            let index = Number(key)+1;
            let complateDescription =
                ` <p> ${index}: Requested by: ${requestor}\r
                - Material: ${materialID} ${this.addDashWithString(materialDesc)} \r
                - Plant: ${plantID} ${this.addDashWithString(plantDesc)}</p>`;
            finalString = finalString + complateDescription + "\n"
        }
        setOutputTextFormat(finalString)
    }
}

registerBrick('01982cf8e0c6fd34245b', GetFormatOfToBeDeletedBCPs);
